import imgSvadhi1 from "./img-svadhi (1).webp";
import imgSvadhi2 from "./img-svadhi (2).webp";

const imgSvadhi = [imgSvadhi1, imgSvadhi2];

export default imgSvadhi;
